export const comments = [
  {
    id: "cmt-01",
    name: "半夜蹲更新的梨",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20of%20a%20small%20rounded%20character%20head%20with%20geometric%20features%2C%20warm%20coral%20and%20cream%20palette%2C%20minimal%20vector%20style%2C%20no%20text&width=100&height=100&seq=guayouhui-cmt01&orientation=squarish",
    time: "2 小时前",
    text: "时间线整理得挺清楚的，比起一条条翻动态舒服多了，收藏慢慢看。",
    likes: 328,
  },
  {
    id: "cmt-02",
    name: "只吃熟瓜",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20of%20a%20calm%20rounded%20face%20shape%20in%20soft%20green%20and%20cream%20tones%2C%20minimal%20vector%20style%2C%20no%20text&width=100&height=100&seq=guayouhui-cmt02&orientation=squarish",
    time: "3 小时前",
    text: "有争议的地方标了双方说法，这点比很多同类型站点做得克制，点赞。",
    likes: 256,
  },
  {
    id: "cmt-03",
    name: "嘴上说不看",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20of%20a%20playful%20rounded%20character%20head%20with%20amber%20accent%20shapes%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=100&height=100&seq=guayouhui-cmt03&orientation=squarish",
    time: "5 小时前",
    text: "说好只看五分钟，结果把相关推荐全点了一遍，这就去看下一篇。",
    likes: 194,
  },
  {
    id: "cmt-04",
    name: "围观群众甲乙",
    avatar: "https://readdy.ai/api/search-image?query=Abstract%20flat%20avatar%20of%20a%20friendly%20geometric%20character%20head%2C%20terracotta%20and%20sand%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=100&height=100&seq=guayouhui-cmt04&orientation=squarish",
    time: "6 小时前",
    text: "还是等官方口径吧，瓜可以吃，但别急着下结论，理性围观最重要。",
    likes: 412,
  },
];